import axios from 'axios'
import { RESERVAS_EM_ABERTO } from '../types'
import { SLOW_REQUEST_CONFIG } from '../../util/loadingUtil'
import { URL } from '../../util/ambienteActions';

export default function deixarReservasEmAberto (empresaId, motivo, reservas) {
  const url = `${URL}/reserva/deixar-reservas-em-aberto`;
  return dispatch => axios.post(url,{ empresaId, motivo,  reservas} , SLOW_REQUEST_CONFIG).then(
      response => dispatch({
        type: RESERVAS_EM_ABERTO,
        payload: response
      })
  );
}
